const Theme = {
  body_background_color: '#B3CAC5',

  header_full_height: true,
  logo_image_url: 'zooecomuseum.png',
  number_font: `PTSerif, 'serif'`,

  button_font: `Raleway, 'sans-serif'`,
  button_text_weight: 600,
  button_radius: 50,
  button_color: '#004D3F',
  button_half_border_color: '#004D3F',

  title_font: `PTSerif, 'serif'`,

  text_font: `Raleway, 'sans-serif'`,
  text_size: 16,

  audio_background_color: '#B3CAC5',

  separator_color: '#B3CAC5',
}

export default Theme
